export const UPLOAD_STRUCTURE01_REQUEST = "UPLOAD_STRUCTURE01_REQUEST";
export const UPLOAD_STRUCTURE01_SUCCESS = "UPLOAD_STRUCTURE01_SUCCESS";
export const UPLOAD_STRUCTURE01_FAILURE = "UPLOAD_STRUCTURE01_FAILURE";

export const UPLOAD_STRUCTURE02_REQUEST = "UPLOAD_STRUCTURE02_REQUEST";
export const UPLOAD_STRUCTURE02_SUCCESS = "UPLOAD_STRUCTURE02_SUCCESS";
export const UPLOAD_STRUCTURE02_FAILURE = "UPLOAD_STRUCTURE02_FAILURE";

export const UPLOAD_STRUCTURE03_REQUEST = "UPLOAD_STRUCTURE03_REQUEST";
export const UPLOAD_STRUCTURE03_SUCCESS = "UPLOAD_STRUCTURE03_SUCCESS";
export const UPLOAD_STRUCTURE03_FAILURE = "UPLOAD_STRUCTURE03_FAILURE";

export const UPLOAD_STRUCTURE04_REQUEST = "UPLOAD_STRUCTURE04_REQUEST";
export const UPLOAD_STRUCTURE04_SUCCESS = "UPLOAD_STRUCTURE04_SUCCESS";
export const UPLOAD_STRUCTURE04_FAILURE = "UPLOAD_STRUCTURE04_FAILURE";

export const UPLOAD_STRUCTURE05_REQUEST = "UPLOAD_STRUCTURE05_REQUEST";
export const UPLOAD_STRUCTURE05_SUCCESS = "UPLOAD_STRUCTURE05_SUCCESS";
export const UPLOAD_STRUCTURE05_FAILURE = "UPLOAD_STRUCTURE05_FAILURE";

export const UPLOAD_STRUCTURE09_REQUEST = "UPLOAD_STRUCTURE09_REQUEST";
export const UPLOAD_STRUCTURE09_SUCCESS = "UPLOAD_STRUCTURE09_SUCCESS";
export const UPLOAD_STRUCTURE09_FAILURE = "UPLOAD_STRUCTURE09_FAILURE";

export const SAVE_OCR_PAYLOAD_REQUEST = "SAVE_OCR_PAYLOAD_REQUEST";
export const SAVE_OCR_PAYLOAD_SUCCESS = "SAVE_OCR_PAYLOAD_SUCCESS";
export const SAVE_OCR_PAYLOAD_FAILURE = "SAVE_OCR_PAYLOAD_FAILURE";
